module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/products_826529.jpg";